module.exports = __webpack_public_path__ + "static/speakingKCDC-aa33c49ab5514cec6d81e2e4004f2d55.png";